<template>
  <a-card :bordered="false">
    <a-col :md="leftColMd" :sm="24" style="max-height: 100vh;overflow-y:scroll;overflow-x: hidden;">
      <a-alert type="info" :showIcon="true">
        <div slot="message">
          {{language['depart.management.selectedDepart']}}：<span v-if="this.currSelected.label">{{ getCurrSelectedTitle() }}</span>
          <a v-if="this.currSelected.label" style="margin-left: 10px" @click="onClearSelected">{{language['depart.management.cancelSelected']}}</a>
        </div>
      </a-alert>
    <template>
            <span style="user-select: none">
              <a-tree
                :show-line="true"
                :show-icon="false"
                :treeData="cmsColTree"
                :expandedKeys="iExpandedKeys"
                :autoExpandParent="autoExpandParent"
                @expand="onExpand"
                :replaceFields="{ children: 'children', title: 'label', key: 'id' }"
                :checkedKeys="checkedKeys"
                :checkStrictly="checkStrictly"
                @select="onSelect"
                :selectedKeys="selectedKeys"
              >

              </a-tree>
            </span>
    </template>
    <div class="drawer-bootom-button">
      <a-dropdown :trigger="['click']" placement="topCenter">
        <a-menu slot="overlay">
          <a-menu-item key="5" @click="expandAll">{{language['system.expenseall']}}</a-menu-item>
          <a-menu-item key="6" @click="closeAll">{{language['system.collegeall']}}</a-menu-item>
        </a-menu>
        <a-button>
          {{language['system.treeoperate']}} <a-icon type="up" />
        </a-button>
      </a-dropdown>
    </div>
    </a-col>

    <a-col :md="rightColMd" :sm="24" v-if="this.rightcolval == 1">
      <a-card :bordered="false">
        <div style="text-align: right;">
          <a-icon type="close-circle" @click="hideCmsCol" />
        </div>
      <div class="table-operator">
        <a-button @click="handleAdd2" v-has="'cmscol_cms:managerInsert'" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
      </div>
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          {{language['emp.cmscol.approver.title']}}
        </div>
        <a-table
          ref="table"
          bordered
          size="middle"
          rowKey="id"
          :columns="columns2"
          :dataSource="dataSource2"
          :pagination="ipagination2"
          :loading="loading2"
          @change="handleTableChange2"
          :scroll="{x:true}"><!-- :scroll="{x:true}" -->

          <span slot="action" slot-scope="text, record">
            <a @click="handleFrozen2(record,'1')" v-has="'cmscol_cms:managerFreeze'" v-if="record.status=='0'">{{language['sys.dict.status.freeze']}}</a>
            <a @click="handleFrozen2(record,'0')" v-has="'cmscol_cms:managerFreeze'" v-if="record.status!='0'">{{language['common.thawButton']}}</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="language['common.deleteConfirmInfo']" v-has="'cmscol_cms:managerDelete'"  @confirm="() => remove2(record)">
                <a>{{language['common.delete']}}</a>
            </a-popconfirm>
        </span>

        </a-table>
      </div>
      </a-card>
    </a-col>
    <emp-col-approver-cms-modal ref="modalForm" @ok="modalFormOk"></emp-col-approver-cms-modal>
    <cms-col-approver-user-cms-modal ref="userModal2" @ok="searchQuery"/>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpColApproverCmsModal from './modules/EmpColApproverCmsModal'
  import { getAction,putAction,deleteAction } from '@/api/manage'
  import CmsColApproverUserCmsModal from './modules/CmsColApproverUserCmsModal'
  import { filterObj } from '@/utils/util'

  export default {
    name: 'EmpColApproverCmsList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpColApproverCmsModal,
      CmsColApproverUserCmsModal
    },
    data () {
      return {
        description: 'emp_col_approver_cms管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'栏目id',
            align:"center",
            dataIndex: 'colId'
          },
          {
            title:'审核人用户id',
            align:"center",
            dataIndex: 'approverId'
          },
          {
            title:'排序',
            align:"center",
            dataIndex: 'sortNo'
          },
          {
            title:'状态（数据字典： entrance_manager_status;0:正常，1:冻结）',
            align:"center",
            dataIndex: 'status'
          },
          {
            title:'是否删除（0否 1是）',
            align:"center",
            dataIndex: 'delFlag'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/hhemp/cmsColApprover/empcolapprovercmss",
          delete: "/hhemp/cmsColApprover/empcolapprovercms",
          deleteBatch: "/hhemp/cmsColApprover/empcolapprovercms/batch",
          exportXlsUrl: "/hhemp/cmsColApprover/export-xls",
          importExcelUrl: "hhemp/cmsColApprover/import-excel",
          list2: "/hhemp/cmsColApprover/list"
          
        },
        dictOptions:{},
        superFieldList:[],
        selectedRowKeys: [],
        cmsColTree: [],
        iExpandedKeys: [],
        autoExpandParent: true,
        allTreeKeys:[],
        selectionRows: [],
        checkedKeys: [],
        selectedKeys: [],
        checkStrictly: true,
        rightcolval:0,
        currSelected: {},
        dataSource2:[],
        loading2: false,
        columns2:[
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:this.$store.getters.language['emp.empEntranceManager.managerWorkNo'],
            align:"center",
            dataIndex: 'approverWorkNo',
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          {
            title:this.$store.getters.language['emp.empEntranceManager.managerName'],
            align:"center",
            dataIndex: 'approverName',
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          {
            title:this.$store.getters.language['emp.empEntranceManager.status'],
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title: this.$store.getters.language['common.action'],
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        ipagination2: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '15', '20'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        isorter2: {
          column: 'createTime',
          order: 'desc'
        },
        filters2: {},
      }
    },
    created() {
      this.loadTree()
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      leftColMd() {
        return this.selectedKeys.length === 0 ? 24 : 12
      },
      rightColMd() {
        return this.selectedKeys.length === 0 ? 0 : 12
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      initDictConfig(){
      },
      loadTree() {
        var that = this
        that.cmsColTree = []
        let langCode = window.sessionStorage.getItem('USER_LANGUAGE');
        getAction("/hhemp/CmsAPI/catalogTreeData",{roleId: process.env.VUE_APP_EMP_CMS_ROLEID, i18n: langCode, siteId: process.env.VUE_APP_EMP_CMS_SITEID}).then((res)=>{
          if (res.success) {
            that.allTreeKeys = [];
            that.cmsColTree = res.result.treeData;
            that.checkedKeys = res.result.idList;
            for (let i = 0; i < res.result.treeData.length; i++) {
              let temp = res.result.treeData[i]
              that.getAllKeys(temp);
            }
            this.iExpandedKeys = that.allTreeKeys;
          }
        })
      },
      onExpand(expandedKeys) {
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      hideCmsCol(){
        this.currSelected = {}
        this.selectedKeys = []
      },
      expandAll () {
        this.iExpandedKeys = this.allTreeKeys
      },
      closeAll () {
        this.iExpandedKeys = []
      },
      getAllKeys(node) {
        this.allTreeKeys.push(node.id)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }
      },
      handleAdd2(){
        let list = [];
        if(this.dataSource2!=null && this.dataSource2.length>0){
          this.dataSource2.forEach(item=>{
            let map = {};
            map.id = item.approverId;
            map.workNo = item.approverWorkNo
            map.realname = item.approverName
            map.disableFlag = "1"
            list.push(map);
          })
        }
        this.$refs.userModal2.edit(list,this.currSelected.id)
      },
      handleFrozen2(record,v){
        record.status = v;
        putAction("/hhemp/cmsColApprover/empcolapprovercms",record).then(res=>{
          if(res.success){
            this.searchQuery();
          }
        })
      },
      remove2(record){
        deleteAction("/hhemp/cmsColApprover/empcolapprovercms",{id:record.id}).then(res=>{
          if(res.success){
            this.searchQuery();
          }
        })
      },
      onSelect(selectKey, e) {
        console.log('selected', selectKey, e)
        this.hiding = false
        let record = e.node.dataRef
        console.log('onSelect-record', record)
        this.selectedKeys = [record.id]
        this.currSelected = Object.assign({}, record)
        this.rightcolval = 1
        this.loadData2()

      },
      handleTableChange2(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter2.column = sorter.field
          this.isorter2.order = 'ascend' == sorter.order ? 'asc' : 'desc'
        }
        this.ipagination2 = pagination
        this.loadData2()
      },
      loadData2(arg) {
        if (!this.url.list2) {
          this.$message.error(this.language['platform.roleUser.pleaseSeturl.list2Status'])
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination2.current = 1
        }
        let params = this.getQueryParams2()
        this.loading2 = true
        params.colId = this.currSelected?this.currSelected.id:''
        getAction(this.url.list2, params).then((res) => {
          if (res.success) {
            this.dataSource2 = res.result
            this.ipagination2.total = res.result.total

          }
          this.loading2 = false
        })

      },
      getQueryParams2() {
        //获取查询条件
        let sqp = {}
        var param = Object.assign(sqp, this.queryParam, this.isorter2, this.filters2)
        param.pageNo = this.ipagination2.current
        param.pageSize = this.ipagination2.pageSize
        return filterObj(param)
      },
      getCurrSelectedTitle() {
        return !this.currSelected.label ? '' : this.currSelected.label
      },
      onClearSelected() {
        this.currSelected = {}
        this.selectedKeys = []
      },
      searchQuery(){
        this.dataSource2 = []
        this.loadData2()
      },
    }

  }
</script>
<style scoped>
  /*@import '~@assets/less/common.less';*/
</style>
